import {REHYDRATE} from 'redux-persist/lib/constants';
import partialRight from 'lodash/partialRight';
import update from 'lodash/update';
import pull from 'lodash/pull';
import get from 'lodash/get';
import {createResourceNamedFiltersSelector} from './selectors';
import ReducerBuilder from 'classes/ReducerBuilder';
import initialState from './initialState';
import {toggleSort} from 'utils/DBUtils';
import {Types} from './actions';

export default ReducerBuilder.make(initialState)
  .forType(REHYDRATE)
  .reduce((state, action) => {
    const currentResources = state.resources;
    const rehydratedResources = get(action, 'payload.viewOptions.resources', {});
    const viewOptionsChanged = Object.keys(currentResources).length !== Object.keys(rehydratedResources).length;

    // if there is a disjunction between the resources configured in this reducer's
    // initial state and those being rehydrated from localStorage, ignore the ones from
    // localStorage so the new state for this reducer will get persisted instead.
    //
    // this handles the case of adding new configs to this reducer (via ./initialState.js)
    // without the user having to clear localStorage when that change has been deployed.
    state.resources = viewOptionsChanged ? currentResources : rehydratedResources;
  })
  .forType(Types.TOGGLE_SORT_FOR_RESOURCE)
  .reduce((state, {resourceType, field}) => {
    const pathToSorts = `resources.${resourceType}.sortOptions.sorts`;
    const updateSorts = partialRight(toggleSort, field);
    update(state, pathToSorts, updateSorts);
  })
  .forType(Types.ADD_FILTER_FOR_RESOURCE)
  .reduce((state, {resourceType, name}) => {
    const namedFilters = createResourceNamedFiltersSelector(resourceType)({viewOptions: state});
    namedFilters.push(name);
  })
  .forType(Types.REMOVE_FILTER_FOR_RESOURCE)
  .reduce((state, {resourceType, name}) => {
    const namedFilters = createResourceNamedFiltersSelector(resourceType)({viewOptions: state});
    pull(namedFilters, name);
  })
  .forType(Types.REPLACE_FILTER_FOR_RESOURCE)
  .reduce((state, {resourceType, toRemove, replaceWith}) => {
    const namedFilters = createResourceNamedFiltersSelector(resourceType)({viewOptions: state});
    pull(namedFilters, toRemove);
    namedFilters.push(replaceWith);
  })
  .forType(Types.SET_RAW_FILTERS_FOR_RESOURCE)
  .reduce((state, {resourceType, filters}) => {
    const pathToRawFilters = `resources.${resourceType}.filterOptions.filters`;
    update(state, pathToRawFilters, () => filters);
  })
  .forType(Types.REMOVE_ALL_FILTERS_FOR_RESOURCE)
  .reduce((state, {resourceType, name}) => {
    const namedFilters = createResourceNamedFiltersSelector(resourceType)({viewOptions: state});
    namedFilters.length = 0;
  })
  .build();



// WEBPACK FOOTER //
// ./public/viewOptions/reducer.js